<template>
  <a-modal
    :visible="visible"
    title="短信测试"
    @ok="handleOk"
    @cancel="handleCancel"
    ok-text="发送"
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <a-form-item
        :label="item"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        v-for="(item, index) in variables"
        :key="index"
      >
        <a-input
          placeholder="请填写"
          v-decorator="[
            item,
            { rules: [{ required: true, message: '请填写变量值' }] },
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        label="手机号码"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <!-- 尽量避免与变量名称冲突 此处使用test_phone -->
        <a-input
          placeholder="请填写手机号"
          v-decorator="[
            'test_phone',
            {
              rules: [
                { required: true, message: '请填写手机号' },
                {
                  message: '请输入正确的手机号码',
                  pattern:
                    '^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\\d{8}$',
                },
              ],
            },
          ]"
        >
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
const fieldRegExp = /\$\{([a-zA-Z0-9_]+)\}/g

export default {
  name: 'CzOperationWebSmsTest',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    scenarioKey: {
      type: String,
      default: '',
    },
    template: {
      type: Object,
      default: () => {},
    },
    tenantId: {
      type: String,
      default: '-1',
    },
  },
  data() {
    return {
      variables: [],
      form: this.$form.createForm(this, {}),
      loading: false,
    }
  },

  created() {
    this.init()
  },

  mounted() {},

  methods: {
    init() {
      // 生成variables
      const { content } = this.template
      if (typeof content === 'string') {
        this.variables = [...content.matchAll(fieldRegExp)].map((m) => m[1])
      }
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (err) return

        console.log({ err, values });
        const { scenarioKey, template, tenantId } = this
        const variables = { ...values }
        delete variables.test_phone

        const params = {
          scenarioKey,
          template,
          phone: values.test_phone,
          variables,
          tenantId
        }
        this.loading = true
        const { code, message } = await this.$api.testTemplateChannel(params)
        if (code == 0) {
          this.$message.success(message)
        } else {
          if (typeof message === 'string') {
            this.$message.warning(message)
          }
        }

        this.loading = false
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="less" scoped>
</style>